<template>
  <Layout class="i-layout">
    <!-- 左侧 -->
    <div class="sider-left">
      <ul class="menu-list">
        <div id="mainMenu" style="margin-bottom: 45px;">
          <li class="menu-item smart_menu_home" v-for="(item,index) in menuList" :title="item.name"
              @click="menuSwitch(item)"
              :class="parentId==item.id?'menu-item smart_menu_home active':'menu-item smart_menu_home'" :key="index">
            <i style="font-size: 22px;" :class="item.icon"></i>
            <div class="menu-item-name" v-text="item.label"></div>
          </li>
        </div>
        <div class="menu-divider"></div>
        <div id="bottom-line-main" style="height:2px"></div>
      </ul>
    </div>
    <!-- 左侧 -->
    <Sider v-if="!isMobile && !hideSider" class="i-layout-sider" :class="siderClasses" :width="menuSideWidth">
      <div class="sub-menu-header" v-text="parentName"></div>
      <i-menu-side :hide-logo="isHeaderStick && headerFix && showHeader"/>
    </Sider>

    <div v-if="!isMobile && !hideSider" class="menu-switch-expand" :style="{'left':leftWidth+'px'}"
         @click="handleToggle">
      <Icon color="#000" size="20" :type="menuCollapse?'ios-arrow-forward':'ios-arrow-back'"></Icon>
    </div>

    <Layout class="i-layout-inside" :class="insideClasses">
      <transition name="fade-quick">
        <Header class="i-layout-header" :class="headerClasses" :style="headerStyle" v-show="showHeader"
                v-resize="handleHeaderWidthChange">
          <i-link class="i-layout-header-logo" :class="{ 'i-layout-header-logo-stick': !isMobile }" to="/">
            <img style="width: 200px;margin-left: 15px;margin-top:-2px;" src="@/assets/images/logo-economy.png">
<!--            <img v-else style="width: 280px;margin-left: 15px;margin-top:-2px;" src="@/assets/images/qy.png">-->
          </i-link>
          <!-- <i-header-logo v-if="isMobile && showMobileLogo" />
          <i-header-logo v-if="!isMobile && isHeaderStick && headerFix" /> -->

          <!-- <i-header-collapse v-if="(isMobile || showSiderCollapse) && !hideSider" @on-toggle-drawer="handleToggleDrawer" /> -->
          <i-header-reload v-if="!isMobile && showReload" @on-reload="handleReload"/>
          <i-menu-head v-if="headerMenu && !isMobile" ref="menuHead"/>
          <i-header-breadcrumb v-if="showBreadcrumb && !headerMenu && !isMobile" ref="breadcrumb"/>
          <i-header-search v-if="showSearch && !headerMenu && !isMobile && !showBreadcrumb"/>
          <div class="i-layout-header-right">
            <i-header-search v-if="(showSearch && isMobile) || (showSearch && (headerMenu || showBreadcrumb))"/>
            <i-menu-head v-if="headerMenu && isMobile"/>
            <i-header-log v-if="isDesktop && showLog"/>
            <i-header-fullscreen v-if="isDesktop && showFullscreen"/>
            <i-header-notice v-if="showNotice"/>
            <i-header-user/>
            <i-header-i18n v-if="showI18n"/>
            <i-header-setting v-if="enableSetting && !isMobile"/>
          </div>
        </Header>
      </transition>
      <Content class="i-layout-content" :class="contentClasses"
               :style="{'margin-left':((!isMobile && !hideSider)?(leftWidth-25):25)+'px'}">
        <transition name="fade-quick">
          <i-tabs v-if="tabs" v-show="showHeader" @on-reload="handleReload"/>
        </transition>
        <div class="i-layout-content-main" style="margin: 10px">
          <keep-alive :include="keepAlive">
            <router-view v-if="loadRouter"/>
          </keep-alive>
        </div>
      </Content>
      <i-copyright/>
    </Layout>
    <div v-if="isMobile && !hideSider">
      <Drawer v-model="showDrawer" placement="left" :closable="false" :class-name="drawerClasses">
        <i-menu-side :lists="lists"/>
      </Drawer>
    </div>
  </Layout>
</template>
<script>
import iMenuHead from './menu-head';
import iMenuSide from './menu-side';
import iHeaderLogo from './header-logo';
import iHeaderCollapse from './header-collapse';
import iHeaderReload from './header-reload';
import iHeaderBreadcrumb from './header-breadcrumb';
import iHeaderSearch from './header-search';
import iHeaderLog from './header-log';
import iHeaderFullscreen from './header-fullscreen';
import iHeaderNotice from './header-notice';
import iHeaderUser from './header-user';
import iHeaderI18n from './header-i18n';
import iHeaderSetting from './header-setting';
import iTabs from './tabs';
import iCopyright from '@/components/copyright';

import {mapState, mapGetters, mapMutations} from 'vuex';
import Setting from '@/setting';

import {requestAnimation} from '@/libs/util';

import dataUtils from '@/utils/dataUtils';

export default {
  name: 'BasicLayout',
  components: {
    iMenuHead,
    iMenuSide,
    iCopyright,
    iHeaderLogo,
    iHeaderCollapse,
    iHeaderReload,
    iHeaderBreadcrumb,
    iHeaderSearch,
    iHeaderUser,
    iHeaderI18n,
    iHeaderLog,
    iHeaderFullscreen,
    iHeaderSetting,
    iHeaderNotice,
    iTabs
  },
  data() {
    return {
      parentId: 0,
      showDrawer: false,
      ticking: false,
      headerVisible: true,
      oldScrollTop: 0,
      isDelayHideSider: false, // hack，当从隐藏侧边栏的 header 切换到正常 header 时，防止 Logo 抖动
      loadRouter: true,
      leftWidth: 268,
      menuList: [],
      lists: [],
      parentName: "项目管理",
      isSystem: false,
    }
  },
  computed: {
    ...mapState('admin/layout', [
      'siderTheme',
      'headerTheme',
      'headerStick',
      'tabs',
      'tabsFix',
      'siderFix',
      'headerFix',
      'headerHide',
      'headerMenu',
      'isMobile',
      'isTablet',
      'isDesktop',
      'menuCollapse',
      'showMobileLogo',
      'showSearch',
      'showNotice',
      'showFullscreen',
      'showSiderCollapse',
      'showBreadcrumb',
      'showLog',
      'showI18n',
      'showReload',
      'logoName',
      'enableSetting'
    ]),
    ...mapState('admin/page', [
      'keepAlive'
    ]),
    ...mapGetters('admin/menu', [
      'hideSider'
    ]),
    // 如果开启 headerMenu，且当前 header 的 hideSider 为 true，则将顶部按 headerStick 处理
    // 这时，即使没有开启 headerStick，仍然按开启处理
    isHeaderStick() {
      let state = this.headerStick;
      if (this.hideSider) state = true;
      return state;
    },
    showHeader() {
      let visible = true;
      if (this.headerFix && this.headerHide && !this.headerVisible) visible = false;
      return visible;
    },
    headerClasses() {
      return [
        `i-layout-header-color-${this.headerTheme}`,
        {
          'i-layout-header-fix': this.headerFix,
          'i-layout-header-fix-collapse': this.headerFix && this.menuCollapse,
          'i-layout-header-mobile': this.isMobile,
          'i-layout-header-stick': this.isHeaderStick && !this.isMobile,
          'i-layout-header-with-menu': this.headerMenu,
          'i-layout-header-with-hide-sider': this.hideSider || this.isDelayHideSider
        }
      ];
    },
    headerStyle() {
      const menuWidth = this.isHeaderStick ? 0 : this.menuCollapse ? 80 : Setting.menuSideWidth;
      return this.isMobile || !this.headerFix ? {} : {
        // width: `calc(100% - ${menuWidth}px)`
        width: `calc(100%)`
      };
    },
    siderClasses() {
      return {
        'i-layout-sider-fix': this.siderFix,
        'i-layout-sider-dark': this.siderTheme === 'dark'
      };
    },
    contentClasses() {
      return {
        'i-layout-content-fix-with-header': this.headerFix,
        'i-layout-content-with-tabs': this.tabs,
        'i-layout-content-with-tabs-fix': this.tabs && this.tabsFix
      };
    },
    insideClasses() {
      return {
        'i-layout-inside-fix-with-sider': this.siderFix,
        'i-layout-inside-fix-with-sider-collapse': this.siderFix && this.menuCollapse,
        'i-layout-inside-with-hide-sider': this.hideSider,
        'i-layout-inside-mobile': this.isMobile
      };
    },
    drawerClasses() {
      let className = 'i-layout-drawer';
      if (this.siderTheme === 'dark') className += ' i-layout-drawer-dark';
      return className;
    },
    menuSideWidth() {
      //   return this.menuCollapse ? 80 : Setting.menuSideWidth;
      return this.menuCollapse ? 0 : Setting.menuSideWidth;
    }
  },
  watch: {
    hideSider() {
      this.isDelayHideSider = true;
      setTimeout(() => {
        this.isDelayHideSider = false;
      }, 0);
    },
    '$route'(to, from) {
      if (to.name === from.name) {
        // 相同路由，不同参数，跳转时，重载页面
        if (Setting.sameRouteForceUpdate) {
          this.handleReload();
        }
      }
    }
  },
  methods: {
    ...mapMutations('admin/layout', [
      'updateMenuCollapse'
    ]),
    ...mapMutations('admin/page', [
      'keepAlivePush',
      'keepAliveRemove'
    ]),
    // menuSwitch(item) {
    //   dataUtils.setData(Setting.key.menuActive, item);
    //   this.parentName = item.name;
    //   let menuAll = dataUtils.getData(Setting.key.menu);
    //   menuAll.forEach(function (item2, index) {
    //     item2.active = false;
    //     if (item.name == item2.name) {
    //       item2.active = true;
    //     }
    //     item2.name = item2.name.substring(0, 2);
    //   })
    //   this.menuList = menuAll;
    //   dataUtils.setData(Setting.key.menu, menuAll);
    //   let path = ''
    //   if (item.children.length > 0) {
    //     path = item.children[0].path
    //   } else {
    //     path = item.path
    //   }
    //   if (this.$route.path != path) {
    //     this.$router.push(path);
    //   }
    // },
    menuSwitch(item) {
      /* 屏幕跳转 */
      if(/\/shp/.test(item.path)){
        this.$router.push(item.path);
        return;
      }
      if (item.path.indexOf("http") >= 0) {
        dataUtils.getData(Setting.key.token)
        item.path = item.path.replace('${token}', dataUtils.getData(Setting.key.token))
        dataUtils.getData(Setting.key.userInfo)
        item.path = item.path.replace('${tenantId}', dataUtils.getData(Setting.key.userInfo).tenantId)
        window.location.href = item.path
        return;
      }
      dataUtils.setData(Setting.key.menu, item.children);
      var menu = dataUtils.getData(Setting.key.menu)
      if(menu.length === 0){
        this.$router.push(item.path);
        this.parentName = item.label;
        if (item.label=='主控台'){
          this.parentId = item.id;
        }
      };
      if (menu.length>0){
        this.parentId = menu[0].parentId;
        this.parentName = item.label;
      }
      /*  */
      if (item.children.length > 0) {
        if (item.children[0].children.length > 0) {
          this.$router.push(item.children[0].children[0].path);
        }
        else {
          this.$router.push(item.children[0].path);
        }
      }
      else {
        this.$router.push(item.path);
      }
    },
    handleToggle() {
      this.updateMenuCollapse(!this.menuCollapse);
      if (this.menuCollapse) {
        this.leftWidth = 68;
      } else {
        this.leftWidth = 268;
      }
    },
    handleToggleDrawer(state) {
      if (typeof state === 'boolean') {
        this.showDrawer = state;
      } else {
        this.showDrawer = !this.showDrawer;
      }
    },
    handleScroll() {
      if (!this.headerHide) return;
      const scrollTop = document.body.scrollTop + document.documentElement.scrollTop;
      if (!this.ticking) {
        this.ticking = true;
        requestAnimation(() => {
          if (this.oldScrollTop > scrollTop) {
            this.headerVisible = true;
          } else if (scrollTop > 300 && this.headerVisible) {
            this.headerVisible = false;
          } else if (scrollTop < 300 && !this.headerVisible) {
            this.headerVisible = true;
          }
          this.oldScrollTop = scrollTop;
          this.ticking = false;
        });
      }
    },
    handleHeaderWidthChange() {
      const $breadcrumb = this.$refs.breadcrumb;
      if ($breadcrumb) {
        $breadcrumb.handleGetWidth();
        $breadcrumb.handleCheckWidth();
      }
      const $menuHead = this.$refs.menuHead;
      if ($menuHead) {
        // todo $menuHead.handleGetMenuHeight();
      }
    },
    handleReload() {
      // 针对缓存的页面也生效
      const isCurrentPageCache = this.keepAlive.indexOf(this.$route.name) > -1;
      const pageName = this.$route.name;
      if (isCurrentPageCache) {
        this.keepAliveRemove(pageName);
      }
      this.loadRouter = false;
      this.$nextTick(() => {
        this.loadRouter = true;
        if (isCurrentPageCache) {
          this.keepAlivePush(pageName);
        }
      });
    }
  },
  mounted() {
    let user=dataUtils.getData(Setting.key.userInfo)
    for (let i = 0; i < user.roleList.length; i++) {
      if (user.roleList[i].roleCode=="ROLE_ADMIN"){
        this.isSystem=true
        break
      }
    }
    // let menuAll = dataUtils.getData(Setting.key.allMenu);
    // let menuActive = dataUtils.getData(Setting.key.menuActive);
    this.menuList = dataUtils.getData(Setting.key.allMenu);
    var menu = dataUtils.getData(Setting.key.menu)
    if(menu.length === 0){
      if (this.menuList[0].label=='主控台'){
        this.parentId = this.menuList[0].id;
      }
    };
    if (menu.length>0){
      this.parentId = menu[0].parentId;
    }

    this.menuList.map((item, index) => {
      item.name = item.label.split("-");
      if (item.id == this.parentId) {
        this.parentName = item.label;
      }
    });
    let that = this;
    // menuAll.forEach(function (item, index) {
    //   item.title = item.name;
    //   item.active = false;
    //   if (menuActive.name == item.name) {
    //     item.active = true;
    //     that.parentName = item.title;
    //   }
    //   item.name = item.name.substring(0, 2);
    // })
    // this.menuList = menuAll;
    document.addEventListener('scroll', this.handleScroll, {passive: true});
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  created() {
    if (this.isTablet && this.showSiderCollapse) this.updateMenuCollapse(true);
  }
}
</script>
<style>
.ivu-tabs-nav .ivu-tabs-tab:hover{color:#00d37f !important;}
</style>
